import { createContext, useContext, useState, ReactNode } from "react";
import type { Domain } from "./api";

export type { Domain } from "./api";

type DomainContextType = {
    domain: Domain;
    setDomain: (domain: Domain) => void;
};

const DomainContext = createContext<DomainContextType | undefined>(undefined);

export const DomainProvider = ({ children }: { children: ReactNode }) => {
    const [domain, setDomain] = useState<Domain>("human"); // human is the default domain

    return <DomainContext.Provider value={{ domain, setDomain }}>{children}</DomainContext.Provider>;
};

export const useDomain = () => {
    const context = useContext(DomainContext);
    if (!context) {
        throw new Error("useDomain must be used within a DomainProvider");
    }
    return context;
};
